export const convertURLtoFile = async (url, setFiles) => {

    const data = await fetch(url).then(r => r.blob())

    if (typeof url !== 'undefined') {
        const ext = url.split(".").pop()
        const filename = url.split("/").pop()
        const metadata = { type: `image/${ext}` }
    
        const file = new File([data], filename, metadata)
        setFiles([file])
    } else {
        setFiles([])
    }
}